import { useState, useEffect } from "react";
import ServicesList from "components/lib/Shared/ServicesList";
import { useDispatch } from "react-redux";
import { setCookie } from "utils/cookie";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Constants } from "config/constants";
import { resetCompanyRelatedSlices } from "state/slices/company";

const SetupYourBusiness = () => {
  const [selectedService, setSelectedService] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (selectedService) {
      setCookie("role", Constants.ROLES.APPLICANT);
      // reset previous company related data
      dispatch(resetCompanyRelatedSlices());
      history.push(`/${selectedService.href}`);
    }
  }, [dispatch, history, selectedService]);

  return (
    <>
      <ServicesList
        selectedService={selectedService}
        setSelectedService={setSelectedService}
        className="mb-4"
      />
    </>
  );
};

export default SetupYourBusiness;
